module.exports = __webpack_public_path__ + "img/giftcards.2098881a.svg";